<script setup>
import { ref } from 'vue' 
import { useRouter } from 'vue-router'
import HeaderNav from "@/components/headerNav.vue";
import FootNav from "@/components/footNav.vue";
import {getBannerApi, getNewsArticleApi} from "@/api";
import {formatTimestamp} from "@/utils/other";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const bannerList = ref([ ])
function  getBanner (){
  getBannerApi({type:4}).then(res => {
    bannerList.value = res.data
  })
}
const router = useRouter()
let id = router.currentRoute.value.query.id

const data = ref({ })
function getDetails () {
  getNewsArticleApi({id}).then(res => {
    data.value = res.data
  })
}
function goNext (e) {
  if (e) {
    id = e
    getDetails()
  }
}
getDetails()
getBanner()
</script>

<template>

  <HeaderNav :isCurrent="3" />
  <div>
    <!-- 轮播图 -->
    <el-carousel height="auto" autoplay>
      <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
        <img :src="item.picUrl" :alt="item.title">
      </el-carousel-item>
    </el-carousel>
  </div>
  <div class="box">
  <!--主体内容 开始-->
  <div class="download">
    <!--右侧区域 开始-->
    <div id="right">
      <div class="right_title"></div>
      <div class="right_body">
        <div class="InfoTitle"><h1>XE270GK中型挖掘机</h1></div>
        <div class="info_from_wrap">
          <b>来源：</b>
          <a href="http://www.baidu.com">百度</a>&nbsp;
          <b>创建时间 ：</b>{{formatTimestamp(data.createTime)}}               <b>点击量：</b>{{data.browseCount}} <b>属于：</b><a href="javascript:;">宣传视频</a>
        </div>
        <!-- 频道/文章内容  开始-->
        <div class="InfoSContent"></div>
        <div class="InfoContent">
          <div>
            <video width='100%' height='675px' :src="data.picUrl" controls="controls">
              您的浏览器不支持 video 标签。
            </video>
          </div>
          <div>
            <div v-html="data.content"></div>
          </div>
        </div>
        <!-- 频道/文章内容  结束-->

        <!-- 当前信息 上一条 下一条  开始-->
        <div class="info_previous_next_wrap">
          <div class="Previous" @click="goNext(data.previousId)">
            <b>{{t('上一条')}}：</b>
            <!-- <a href="" title="">暂无上一条数据</a> -->
            <span class="pointer" v-if="data.previousId">{{data.previousTitle}}</span>
            <span class="pointer" v-else>{{t('暂无上一条数据')}}</span>
          </div>
          <div class="Next" @click="goNext(data.nextId)">
            <b>{{t('下一条')}}：</b>

            <span class="pointer" v-if="data.nextId">{{data.nextTitle}}</span>
            <span class="pointer" v-else>{{t('暂无下一条数据')}}</span>
          </div>
        </div>
        <!-- 当前信息 上一条 下一条  结束-->
      </div>
      <div class="right_bottom"></div>
    </div>
    <!--右侧区域 结束-->
    <div class="clear"></div>
  </div>
  <!--主体内容 结束-->
    <div>
      <FootNav />
    </div>
  </div>
</template>

<style scoped lang="scss">
.video-details {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
  
  h1 {
    color: #333;
    margin-bottom: 20px;
  }
  
  .video-container {
    margin-top: 20px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 8px;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>